import { render } from "./GuardianEditTable.vue?vue&type=template&id=150a7e3e&scoped=true&ts=true"
import script from "./GuardianEditTable.vue?vue&type=script&lang=ts"
export * from "./GuardianEditTable.vue?vue&type=script&lang=ts"

import "./GuardianEditTable.vue?vue&type=style&index=0&id=150a7e3e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150a7e3e"]])

export default __exports__